module.exports = __webpack_public_path__ + "static/media/Tyrantrum_gaussian2.1a41d46f.png";